import DeviceList from './DeviceList';
export default DeviceList;
